import { PropsWithChildren } from "react";
import { useUserContext } from "../../../context/user.context";
import PageLoader from "../../components/PageLoader/PageLoader";
import Forbidden from "../pages/Forbidden/Forbidden";

// Gates admin screens behind the Super Admin role. Checks `loading` first so
// a Super Admin never sees a flash of Forbidden (or a non-Super-Admin a
// flash of admin content) while the user profile is still resolving.
function RequireSuperAdmin({ children }: PropsWithChildren<{}>) {
  const { role, loading } = useUserContext();

  if (loading) {
    return <PageLoader />;
  }

  if (role !== "super") {
    return <Forbidden />;
  }

  return <>{children}</>;
}

export default RequireSuperAdmin;
